import axios from "axios";
import { hotjar } from "react-hotjar";
import getHotjarUserID from './hotjar';

const apiClient = axios.create({
  baseURL: "/api/report",
  headers: {
    "Content-Type": "application/json",
  },
});

function Report(data, userId, submitionId) {
  const record = { ...data, userId: userId, submitionId: submitionId };
  const hjID = getHotjarUserID();

  if (hjID !== "") {
    record.hjID = hjID;
  }

  if (hotjar.initialized()) {
    if (data.action) {
      hotjar.event(data.action);
    }
  }

  return apiClient.post("/record", record);
}

function ReportPageView(page, userId, submitionId) {
  const event = {
    action: "view",
    category: "page-view",
    description: `viewed the "${page}" page`,
    value: window.location.pathname,
    userId: userId,
    submitionId: submitionId,
  };
  const hjID = getHotjarUserID();

  if (hjID !== "") {
    event.hjID = hjID;
  }

  return apiClient.post("/record", event);
}

export { Report, ReportPageView };
